/*
 * Filename: d:\projects\AutoFiFront\src\Content\CarInfo\CarInfo.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Friday, January 13th 2023, 2:10:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import { BiTachometer } from 'react-icons/bi';
import { TbGasStation,  } from "react-icons/tb";
import { FaExternalLinkAlt } from "react-icons/fa";
import { BsCalendarDate as BsCalendar2Week } from "react-icons/bs";
import { GiGearStickPattern } from "react-icons/gi";
import { TfiLocationPin } from "react-icons/tfi";
import { MdOutlineColorLens } from "react-icons/md";
import { TbSteeringWheel } from "react-icons/tb";
import styles from "Content/Car/CarInfo/CarInfo.module.css";
import CarInfoIcon from "Theme/Component/CarInfoIcon";
import translator from "MultiLanguage/TranslationWrapper";

export type CarInfoTypeProps = {
    Brand: string,
    Model: string,
    Version: string,
    Energy: string,
    Gears: string,
    CirculationDate: Date,
    Mileage: number,
    Park: string,
    Color: string,
    Link: string,
    Nb_Col: number,
    Nb_Elem: number,
    Car_Type: string,
    themeColor?: string,
    hasEllipsis?: boolean
};

function CarInfo (props: CarInfoTypeProps) {
    const Car_Brand = `${props.Brand.toUpperCase()} ${props.Model.toUpperCase()}`;
    const Car_Underline= props.Version.toUpperCase();
    const Car_Energy = translator.decode(`energyType.${props.Energy.toLowerCase()}`).toUpperCase();
    const Car_Gears = props.Gears.toUpperCase();
    const Car_CirculationDate = props.CirculationDate.toLocaleDateString();
    const Car_Mileage = props.Mileage;
    const Car_Park = props.Park.toUpperCase();
    const Car_Color = props.Color.toUpperCase();
    const Car_Type = props.Car_Type.toUpperCase();
    const Link = props.Link;
    const Nb_Elem = props.Nb_Elem;
    const Nb_col = props.Nb_Col;
    const ClassNameCol = 12 / Nb_col;
    const Nb_Row = Math.trunc(Nb_Elem / Nb_col) + Nb_Elem % Nb_col;

    const itemToDisplay = [
        {
            name: Car_Mileage + " " + "KM",
            icon: <BiTachometer/>
        },
        {
            name: Car_Energy,
            icon: <TbGasStation />
        },
        {
            name: Car_Gears,
            icon: <GiGearStickPattern/>
        },
        {
            name: Car_CirculationDate,
            icon: <BsCalendar2Week/>
        },
        {
            name: Car_Color,
            icon: <MdOutlineColorLens/>
        },
        {
            name: Car_Park,
            icon: <TfiLocationPin/>
        },
        {
            name: Car_Type,
            icon: <TbSteeringWheel/>
        },
        // {
        //     name: Link,
        //     icon: <FaExternalLinkAlt />
        // }
    ];
    const myRows: any[] = [];
    let k = 0;
    for (let i = 0; i < Nb_Row; ++i){
        const myItems: any[] = [];
        for (let j = 0; j < Nb_col; ++j){
            if (k < itemToDisplay.length && itemToDisplay[k].name != "" &&  itemToDisplay[k].name != null) {
                if (itemToDisplay[k].name == Link) {
                    myItems.push(<div key={Math.random()} className={`${styles.car_info_sub_data} col-${ClassNameCol}`}>
                        <CarInfoIcon bgColor={props.themeColor}>{itemToDisplay[k].icon}</CarInfoIcon>
                        <a href={Link} className={`${styles.linkAuto}`} target="_blank">{translator.decode("dynamic.report").toUpperCase()}</a>
                    </div>)
                } else {
                    myItems.push(<div key={Math.random()} className={`${styles.car_info_sub_data} col-${ClassNameCol}`}>
                        <CarInfoIcon bgColor={props.themeColor}>{itemToDisplay[k].icon}</CarInfoIcon>
                        {itemToDisplay[k].name}
                    </div>)
                }
            }
            ++k;
        }
        myRows.push(<div key={Math.random()} className={`${styles.car_info_row} row`} >{myItems}</div>);
    }

    return (
        <div className={`${styles.car_info}`}>
            <div className={`${styles.car_info_name}`}>
                <h2 className={`${Car_Brand.length > 20 ? styles.titleShort : ""}`}> {Car_Brand} </h2>
                <h3 className={`${props.hasEllipsis ? styles.titleEllipsis : ""}`}> {Car_Underline} </h3>
            </div>
            {myRows}
        </div>
    );
}

export default CarInfo;
